import React from "react";

const Chapter1 = () => {
  return (
    <>
      <h2>Contaminants of Emerging Concern (CEC) Storyline</h2>
      <img
        style={{ width: "88%", margin: "20px auto" }}
        alt="cherry creek delgany"
        src="/static/img/storylines/cherry-creek-delgany.jpg"
      />
      <p>
        Don't know much about Contaminants of Emerging ? The storyline is the
        perfect place to start. Learn what CECs are, how they get into the South
        Platte River and its tributaries and what can be done to reduce their
        pollutant load.
      </p>
      <p>
        The use of human-made chemicals by people and animals have profound
        beneficial effects such as the prevention, diagnosis, and treatment of
        diseases, increased production of crops, and other improvements in
        lifestyle. However, these beneficial effects have a cost. Water
        resources are degraded by runoff from land and when people ingest
        chemicals and excrete them in their waste. Wastewater treatment
        facilities and septic tank discharges do not fully remove these
        chemicals. They are found in every environment around the planet.
        Collectively these chemicals are referred to as “Contaminants of
        Emerging Concern” (CECs) and they include pharmaceuticals, personal care
        products, hormones, plastics and other consumer products, chemicals, and
        pesticides. Once released into the environment, CECs may impact the
        health of fish, wildlife, and people.
      </p>
    </>
  );
};

export default Chapter1;
